import React from 'react';
import UserTemplateShell from '../components/UserTemplateShell';
import UserPricePage from './UserPricePage';

function UserPricelistTemplatePage() {
  return (
    <UserTemplateShell title="Upgrade Premium" subtitle="Pilih paket aktif Anda">
      <UserPricePage />
    </UserTemplateShell>
  );
}

export default UserPricelistTemplatePage;
